import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '@services/storage.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized-account',
  templateUrl: './unauthorizedAccount.component.html',
  styleUrls: ['./unauthorized.component.css'],

  imports: [TranslateModule]
})
export class UnauthorizedAccountComponent implements OnInit {
  codeErreur: string;

  private route = inject(ActivatedRoute);
  private oauthService = inject(OAuthService);
  private storageService = inject(StorageService);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.codeErreur = params['code'];
    });
  }

  logout() {
    this.storageService.clearStorage();
    this.oauthService.logOut();
  }
}
